import React from 'react';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { Stack } from 'common/design-system/components-v2';

export const IssueCVSSCellRenderer: React.FC<ICellRendererParams> = (params) => (
    <Stack justifyContent={'center'} alignItems={'center'}>
        {params.value}
    </Stack>
);
